import { render, staticRenderFns } from "./Record.vue?vue&type=template&id=0e85c54a&scoped=true&"
import script from "./Record.vue?vue&type=script&lang=ts&"
export * from "./Record.vue?vue&type=script&lang=ts&"
import style0 from "./Record.vue?vue&type=style&index=0&id=0e85c54a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e85c54a",
  null
  
)

export default component.exports